'use strict';

// #SNOT
// Not SFRA 6x script upgrade compatible.Selective changes applied.

var formValidation = require('theme/js/components/formValidation');
var createErrorNotification = require('theme/js/components/errorNotification');
var util = require('improove/util/util');
var liveFormValidation = require('theme/js/components/liveFormValidation');
import { callTurnstile } from 'shared/js/turnstileWidget';

var login = require('base/login/login');

import siteConfig from 'shared/js/siteConfig';

liveFormValidation($('form'));

function validateNewBasket() {
    $.ajax({
        url: window.SitePreferences.VALIDATE_BASKET_URL,
        type: 'GET',
        dataType: 'json',
        success: function (data) {
            if (data && data.sessionRefreshed) {
                // Session refreshed
            }
        }
    });
}

login.login = function () {
    $('[data-login-form]').submit(function (e) {
        e.preventDefault();
        var form = $(this);
        var url = form.attr('action');
        $(this).find('.login-button').prop('disabled', true);
        $(this).find('.action-button').addClass('disable-action-button');
        $('[data-login-form]').trigger('login:submit', e);

        var formEl = this;
        var formData = form.serialize();
        const loginUser = function (turnstileResponse) {
            var data = (formData.replace(/&?cf-turnstile-response=[^&]*/g, '') + '&action=login').replace(/^&/, '');
            if (turnstileResponse) {
                data += '&cf-turnstile-response=' + encodeURIComponent(turnstileResponse);
            }
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: data,
                success: function (data) {
                    if (!data.success) {
                        formValidation(form, data);
                        $('[data-login-form]').trigger('login:error', data);
                        $('.login-button').prop('disabled', false);
                        $('.action-button').removeClass('disable-action-button');
                    } else {
                        $('[data-login-form]').trigger('login:success', data);
                        validateNewBasket(data.sessionSetupURL);
                        location.href = data.redirectUrl;
                        // $('.login-button').prop('disabled', false);
                    }
                },
                error: function (data) {
                    if (data && data.responseJSON && data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                        $('.login-button').prop('disabled', false);
                    } else if (data && data.responseJSON) {
                        $('[data-login-form]').trigger('login:error', data);
                        $('.login-button').prop('disabled', false);
                    }

                    $('.action-button').removeClass('disable-action-button');
                    $('.login-button').prop('disabled', false);
                }
            });
        };

        if (window.SitePreferences.TURNSTILE_ENABLED) {
            callTurnstile(loginUser, formEl.querySelector('.login-turnstile-container'));
        } else {
            loginUser('');
        }

        return false;
    });
};

// #CDIFF #DONE FM Flag support - do not allow registration
if (siteConfig.get('customer.registration.enabled')) {
    login.register = function () {
        $('[data-registration-form]').submit(function (e) {
            e.preventDefault();
            var form = $(this);
            var url = form.attr('action');
            $(this).find('.login-create-account-button').prop('disabled', true);
            $(this).find('.action-button').addClass('disable-action-button');
            $('[data-registration-form]').trigger('login:register', e);

            var formEl = this;
            var formData = form.serialize();
            const registerUser = function (turnstileResponse) {
                var data = (formData.replace(/&?cf-turnstile-response=[^&]*/g, '') + '&action=createaccount').replace(/^&/, '');
                if (turnstileResponse) {
                    data += '&cf-turnstile-response=' + encodeURIComponent(turnstileResponse);
                }
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: data,
                    success: function (data) {
                        if (!data.success) {
                            $('form.registration').trigger('login:register:error', data);
                            formValidation(form, data);
                            $('.login-create-account-button').prop('disabled', false);
                            $('.action-button').removeClass('disable-action-button');
                        } else {
                            $('form.registration').trigger('login:register:success', data);
                            validateNewBasket(data.sessionSetupURL);
                            location.href = data.redirectUrl;
                        }
                    },
                    error: function (err) {
                        if (err && err.responseJSON && err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                            $('.login-create-account-button').prop('disabled', false);
                        } else if (err && err.responseJSON) {
                            createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                            $('.login-create-account-button').prop('disabled', false);
                        }

                        $('.action-button').removeClass('disable-action-button');
                        $('.login-create-account-button').prop('disabled', false);
                    }
                });
            };

            if (window.SitePreferences.TURNSTILE_ENABLED) {
                callTurnstile(registerUser, formEl.querySelector('.register-turnstile-container'));
            } else {
                registerUser('');
            }

            return false;
        });
    };

    // #ADDIN #CDIFF #DONE BS <> GG - No in BS, but present in GG
    if (siteConfig.get('customer.registration.registrationTabFlag')) {
        login.openRegistrationTab = function () {
            $('body').on('click', '[data-open-register-tab]', function (e) {
                e.preventDefault();

                if (!$(this).hasClass('active')) {
                    // Remove class Active from other Tabs
                    $('[data-tab-header]').removeClass('active');
                    $('[data-tab-content]').removeClass('active');

                    // Set Tab Header Item as Active
                    $(this).addClass('active');

                    // Set Tab Content Item as Active
                    var clickedTab = $(this).data('tab-header');
                    $('[data-tab-header=' + clickedTab + ']').addClass('active');
                    $('[data-tab-content=' + clickedTab + ']').addClass('active');
                    window.scrollTo(0, 0);
                }
            });
        };
    }
}

module.exports = login;
